var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTrashGrey = function SvgTrashGrey(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13925 1.1665L3.02759 3.284",
    stroke: "#A0ACB7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86084 1.1665L10.9725 3.284",
    stroke: "#A0ACB7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 4.57926C1.16675 3.5001 1.74425 3.4126 2.46175 3.4126H11.5384C12.2559 3.4126 12.8334 3.5001 12.8334 4.57926C12.8334 5.83343 12.2559 5.74593 11.5384 5.74593H2.46175C1.74425 5.74593 1.16675 5.83343 1.16675 4.57926Z",
    stroke: "#A0ACB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69336 8.1665V10.2373",
    stroke: "#A0ACB7",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37671 8.1665V10.2373",
    stroke: "#A0ACB7",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04175 5.8335L2.86425 10.8735C3.05091 12.0052 3.50008 12.8335 5.16842 12.8335H8.68592C10.5001 12.8335 10.7684 12.0402 10.9784 10.9435L11.9584 5.8335",
    stroke: "#A0ACB7",
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-grey.60fd4fb4.svg";
export { ForwardRef as ReactComponent };